import {
  DELETE_RATIO_MUTATION,
  EDIT_RECEIPT_RATIO_MUTATION,
  ADD_RECEIPT_RATIO_MUTATION,
  POST_RETURN_RATIO_MUTATION,
  GET_RATIO_CLIENT_DETAIL_MUTATION,
  GET_RATIO_MUTATION,
  GET_DEALER_PROFIT_MUTATION,
  POST_RATIO_MUTATION,
  GET_RATIO_CLIENT_MUTATION,
  GET_DEALER_REPORT_MUTATION,
  GET_ALL_DEALER_PROFIT_MUTATION,
  GET_ALL_DEALER_RECEIPT_MUTATION,
} from "@/store/storeConstants";
export default {
  [GET_RATIO_MUTATION](state, payload) {
    state.ratios = payload.ratios;
    state.ratioLoaded = payload.loaded;
    state.totalRatio = payload.totalRatio;
    state.totalBonus = payload.totalBonus;
    state.totalProtaction = payload.totalProtaction;
    state.finalRatio = payload.finalRatio;
    state.totalDiscount = payload.totalDiscount;
    state.countOrderReturn = payload.countOrderReturn;
    state.countOrderDone = payload.countOrderDone;
  },

  [GET_DEALER_REPORT_MUTATION](state, payload) {
    state.result = payload.result;
    state.ratioLoaded = payload.loaded;
    state.totalRatioResult = payload.totalRatioResult;
    state.totalProtactionResult = payload.totalProtactionResult;
    state.finalRatioResult = payload.finalRatioResult;
    state.totalDiscountResult = payload.totalDiscountResult;
    state.countOrderReturnResult = payload.countOrderReturnResult;
    state.countOrderDoneResult = payload.countOrderDoneResult;
  },

  [POST_RATIO_MUTATION](state, payload) {
    state.postRtio = payload;
  },

  [GET_ALL_DEALER_RECEIPT_MUTATION](state, payload) {
    state.payments = payload.payments;
    state.total = payload.total;
  },

  [GET_ALL_DEALER_PROFIT_MUTATION](state, payload) {
    state.allDealerProfit = payload.allDealerProfit;
    state.totalAllDealerProfit = payload.totalAllDealerProfit;
  },

  [GET_DEALER_PROFIT_MUTATION](state, payload) {
    state.countOrderReturnDealer = payload.countOrderReturnResult;
    state.countOrderDoneDealer = payload.countOrderDoneResult;
    state.totalProfit = payload.totalProfit;
  },

  [GET_RATIO_CLIENT_MUTATION](state, payload) {
    state.allRatios = payload.allRatios;
    state.allRatioLoaded = payload.allRatioLoaded;
  },

  [GET_RATIO_CLIENT_DETAIL_MUTATION](state, payload) {
    state.ratioDetails = payload.ratioDetails;
    state.ratioDetailsLoaded = payload.ratioDetailsLoaded;
  },
  [POST_RETURN_RATIO_MUTATION](state, payload) {
    state.PostreturnRatio = payload;
  },

  [ADD_RECEIPT_RATIO_MUTATION](state, payload) {
    state.postReceipt = payload;
  },

  [EDIT_RECEIPT_RATIO_MUTATION](state, payload) {
    state.postReceipt = payload;
  },
  [DELETE_RATIO_MUTATION](state, payload) {
    state.deleteing = payload;
  },
};
